import { apiPost, apiStore } from '../../../modules/apiHelper';
import { toBoolean } from '../../../modules/dataHelper';

export default {
  async getMyTasks(context, strict = false) {
    const menteeStoreData = context.state.tasks;
    // console.log(menteeStoreData);
    if (menteeStoreData.length > 0 && !strict) {
      return menteeStoreData;
    }

    const goals = await context.dispatch('getGoals', []);

    const data = new FormData();
    data.set('menteeid', context.rootState.user.id);

    return apiPost('task_list_mentee', data, 1)
      .catch((err) => {
        console.warn('Cannot get your tasks \n', err);
      })
      .then((res) => {
        if (!res) return false;
        if (toBoolean(res.data.error)) {
          console.warn('Error in getting your tasks \n', res.data.message);
          return false;
        }

        // remove group task
        const tasks = (res.data.task_list_mentee || []).filter((task) => (!!Number(task.groupid)) === false);

        const hasGroupTasks = (res.data.task_list_mentee || []).find((task) => !!Number(task.groupid));
        context.commit('updateHasGroupTasks', hasGroupTasks);

        const mappedTasks = tasks.map((task) => {
          // eslint-disable-next-line eqeqeq
          const taskGoal = goals.find((goal) => goal.id == task.subgoalid);

          return {
            ...task,
            goal: taskGoal || {},
          };
        });

        mappedTasks.forEach((task) => {
          context.commit('addTask', task);
        });

        return true;
      });
  },
  async markTaskComplete(context, [taskId, reportText = undefined, reportResource = false]) {
    if (!taskId) return false;
    const task = await context.dispatch('getTask', [taskId]);
    const userId = context.getters.userId.toString();

    if (userId !== task.mentorid && userId !== task.userid) return false;

    const formData = new FormData();
    formData.set('taskid', taskId);

    if (reportText) {
      formData.set('review', reportText);
      formData.set('text', reportResource ? 2 : 1);
    } else {
      formData.set('text', 0);
    }

    const response = await apiPost('submit_task_report', formData, 1)
      .catch((err) => {
        console.warn('markTaskComplete ERROR', err);
      })
      .then(async (res) => {
        if (!res) return false;
        if (toBoolean(res.error)) return false;

        // get the updated task Details
        await apiStore.removeItem(`task/${taskId}`);
        context.dispatch('getTask', [taskId])
          .then((newTask) => {
            if (newTask.id) {
              context.commit('updateTask', {
                id: newTask.id,
                prop: 'status',
                value: newTask.status,
              });
            }
          });

        return true;
      });

    return response;
  },
};
